import React from "react";

export function EternalReturnIcon() {
  // "영원한 회귀"(죽음과 부활의 순환)를 상징하는 루프 화살표
  return (
    <svg className="hub-icon" viewBox="0 0 100 100" fill="none" stroke="#a78bfa" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round">
      <path d="M82 47 A32 32 0 1 1 74 29" />
      <path d="M82 31 L82 47 L66 47" />
    </svg>
  );
}

export function PubgIcon() {
  // 배틀로얄 낙하 강하를 상징하는 낙하산
  return (
    <svg className="hub-icon" viewBox="0 0 100 100">
      <path d="M12 42 C12 18 88 18 88 42 Z" fill="#8bc34a" />
      <path d="M28 42 C28 26 28 20 32 18" stroke="#1e2a1a" strokeWidth="1.5" fill="none" opacity="0.5" />
      <path d="M50 42 L50 18" stroke="#1e2a1a" strokeWidth="1.5" fill="none" opacity="0.5" />
      <path d="M72 42 C72 26 72 20 68 18" stroke="#1e2a1a" strokeWidth="1.5" fill="none" opacity="0.5" />
      <g stroke="#8bc34a" strokeWidth="2">
        <line x1="18" y1="42" x2="44" y2="72" />
        <line x1="82" y1="42" x2="56" y2="72" />
        <line x1="50" y1="42" x2="44" y2="72" />
        <line x1="50" y1="42" x2="56" y2="72" />
      </g>
      <circle cx="50" cy="78" r="7" fill="#8bc34a" />
    </svg>
  );
}

export function BadukIcon() {
  const gridLines = [20, 35, 50, 65, 80];
  return (
    <svg className="hub-icon" viewBox="0 0 100 100">
      <g stroke="#d4a656" strokeWidth="1.5">
        {gridLines.map((v) => (
          <line key={`h${v}`} x1="15" y1={v} x2="85" y2={v} />
        ))}
        {gridLines.map((v) => (
          <line key={`v${v}`} x1={v} y1="15" x2={v} y2="85" />
        ))}
      </g>
      <circle cx="35" cy="35" r="7" fill="#1a1a1a" />
      <circle cx="65" cy="50" r="7" fill="#f5f0e6" />
      <circle cx="50" cy="65" r="7" fill="#1a1a1a" />
    </svg>
  );
}

export function LostArkIcon() {
  // 고대 유물(아크)의 보석을 상징하는 컷팅된 젬
  return (
    <svg className="hub-icon" viewBox="0 0 100 100">
      <polygon points="50,10 85,35 72,80 28,80 15,35" fill="#e0a94a" stroke="#8a5a1e" strokeWidth="2" />
      <polygon points="50,10 85,35 50,50" fill="#f2c66d" />
      <polygon points="50,10 15,35 50,50" fill="#c98a3e" />
      <polygon points="28,80 50,50 72,80" fill="#b87a30" />
      <line x1="50" y1="10" x2="50" y2="50" stroke="#8a5a1e" strokeWidth="1.5" />
      <line x1="15" y1="35" x2="85" y2="35" stroke="#8a5a1e" strokeWidth="1.5" />
    </svg>
  );
}
